module.exports = __webpack_public_path__ + "static/media/vote.a63d4053.png";